import React from 'react'

export default function MyEvents() {
    return (
        <div>
            <h2>My Events</h2>
        </div>
    )
}
